
import React from 'react';
import Immutable from 'immutable';
import classNames from 'classnames';
import config from 'react-global-configuration';

import { Paragraph } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import BasicPageRelatedItems from '../RelatedItems';
import { WysiwygField, Breadcrumbs, DynamicMediaItem } from '../../../../components';

import './style.scss';
import { NLDOET_DOMAIN } from '../../../../config/constants';

const NodeBasicPageFull = ({ entity, className }) => {
  const domain = config.get('CURRENT_DOMAIN');
  const classes = classNames(className, 'BasicPage');
  const relatedItems = entity.getIn(['field_related'], Immutable.List());
  const id = entity.getIn(['nid', 0, 'value']);
  const image = entity.getIn(['field_image', '0'], null);
  const paragraphs = entity.getIn(['field_paragraphs'], Immutable.List());

  if (!entity.getIn(['title', 0, 'value']) && !entity.getIn(['body', 0, 'processed'])) {
    return null;
  }

  return (
    <article typeof="schema:WebPage" className={classes}>
      <Container>
        <div className="row">
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <Breadcrumbs includeCurrent hideHome />
            <div className="BasicPage">
              <h1 className="BasicPage__title">{entity.getIn(['title', 0, 'value'])}</h1>

              {entity.getIn(['body', 0, 'processed']) ? (
                <WysiwygField
                  property="schema:text"
                  className="BasicPage__body"
                  html={entity.getIn(['body', 0, 'processed'], '')}
                />
              ) : null}

              {image && (
                <div className="BasicPage__image">
                  <DynamicMediaItem media={image.toJS()} />
                </div>
              )}
            </div>
          </div>
        </div>
        {domain === NLDOET_DOMAIN && (
          <div className="NLdoetElement" />
        )}
      </Container>
      <div className="Paragraphs">
        {
          paragraphs.map((item, index) => {
            const paragraphId = item.get('target_id');
            const paragraph = item.getIn(['entity']);
            return (
              <Paragraph key={paragraphId} entity={paragraph} id={paragraphId} />
            );
          })
        }
      </div>
      <BasicPageRelatedItems relatedItems={relatedItems} id={id} />
    </article>
  );
};

export default NodeBasicPageFull;
